jQuery(document).ready(function($){

    $('svg.radial-progress').each(function( index, value ) { 
        $(this).find($('circle.complete')).removeAttr( 'style' );
      });
     
    if ($('svg.radial-progress').length > 0) {
        $(".components-pointer").tooltip({
            'container': 'body',
            'placement': 'top'
        });
    }  
  
      $(window).scroll(function(){
        $('svg.radial-progress').each(function( index, value ) { 
          if ( 
              $(window).scrollTop() > $(this).offset().top - ($(window).height()*0.9) &&
              $(window).scrollTop() < $(this).offset().top + $(this).height() - ($(window).height()*0.1)
          ) {
            if ($(this).hasClass('not-start')) {
                let percent = $(value).data('percentage');
                // Get radius of the svg's circle.complete
                let radius = $(this).find($('circle.complete')).attr('r');
                // Get circumference (2πr)
                let circumference = 2 * Math.PI * radius;
                // Get stroke-dashoffset value based on the percentage of the circumference
                let strokeDashOffset = circumference - ((percent*circumference)/100);
                $(this).find($('circle.complete')).animate({'stroke-dashoffset': strokeDashOffset}, 2800);            
                let radid = $(this).attr('id');
                $(this).removeClass('not-start'); 
                let counter = 0;
                let intervalID = null;
                intervalID = window.setInterval(function(){
                    let step = 2;
                    if (counter + step >= percent) {
                        counter = percent;
                        $('#'+radid + ' .percentage .prc-number').empty().append(counter);
                        clearInterval(intervalID);
                        return;
                    }
                    counter += step;
                    $('#'+radid + ' .percentage .prc-number').empty().append(counter);
                }, 40);
              }
          }
        });
      }).trigger('scroll');   
});